// Fixed bottom-right action button. The slot is one stable affordance
// across every phase — fixed width, fixed position — so the label can
// rotate ("PLAY 3 MANA", "ATTACK", "END TURN", "CONFIRM BLOCKS (3)",
// "CONTINUE", …) without the button jittering around the corner.

import type { pixelTheme } from "../../theme/pixel";
import { glowShadow } from "../../theme/styles";

export function EndTurnButton({
  label,
  onClick,
  disabled,
  accent,
  theme,
}: {
  label: string;
  onClick: () => void;
  disabled: boolean;
  accent: string;
  theme: typeof pixelTheme;
}) {
  return (
    <button
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      className="doi-btn"
      style={{
        position: "fixed",
        right: 24,
        bottom: 24,
        zIndex: 10,
        width: 220,
        padding: "10px 0",
        textAlign: "center",
        fontFamily: theme.fontDisplay,
        fontSize: 14,
        fontWeight: 700,
        letterSpacing: theme.letterSpacing,
        textTransform: theme.uppercase ? "uppercase" : "none",
        color: disabled ? theme.inkFaint : theme.panelEdgeStrong,
        background: disabled ? theme.bgDeep : accent,
        border: `3px solid ${theme.panelEdgeStrong}`,
        borderRadius: theme.radius.button,
        cursor: disabled ? "not-allowed" : "pointer",
        boxShadow: disabled ? "none" : glowShadow(theme, theme.accentGlow, 1.4),
        imageRendering: "pixelated",
        textShadow: disabled ? "none" : "1px 1px 0 rgba(255,255,255,0.4)",
        transition: "none",
      }}
    >
      {label}
    </button>
  );
}
